import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { FaAward, FaUsers, FaMapMarkerAlt, FaHeart, FaCheckCircle, FaCar,  FaClock, FaHeadset, FaEnvelope, FaTwitter, FaLinkedin } from 'react-icons/fa';
import './aboutus.css';

import { Link } from "react-router-dom";


import { FaEye, FaBullseye, FaStar, FaShieldAlt, FaRocket } from 'react-icons/fa';


// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: "backOut"
    }
  },
  hover: {
    scale: 1.05,
    y: -10,
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

const imageVariants = {
  hidden: { opacity: 0, x: 100 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
      ease: "easeOut"
    }
  },
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.4,
      ease: "easeInOut"
    }
  }
};

const statVariants = {
  hidden: { opacity: 0, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: "backOut"
    }
  }
};

const floatingAnimation = {
  y: [0, -15, 0],
  transition: {
    duration: 4,
    repeat: Infinity,
    ease: "easeInOut"
  }
};

function AboutUs() {
  const teamMembers = [
    {
      name: "Achala Liyanaarachchi",
      role: "Founder & CEO",
      image: "/achala.jpeg",
      description: "5+ years in transportation industry",
      linkedin: "https://www.linkedin.com/in/achala-liyanaarachchi-aaa52a38a/?originalSubdomain=lk",
      email: "achalal1995@gmail.com",
    },
    {
      name: "Ama Weerapura",
      role: "Head of Operations",
      image: "/Ama Weerapura.jpeg",
      description: "Expert in fleet management and logistics",
       linkedin: "",
      email: "amaweerapuara@gmail.com"
    }
  ];

  const values = [
    {
      icon: <FaCar />,
      title: "Reliable Service",
      description: "Punctual and dependable transportation you can count on"
    },
    {
      icon: <FaShieldAlt />,
      title: "Safety First",
      description: "Well-maintained vehicles and licensed professional drivers"
    },
    {
      icon: <FaClock />,
      title: "24/7 Availability",
      description: "Round-the-clock service for all your travel needs"
    },
    {
      icon: <FaHeadset />,
      title: "Customer Focus",
      description: "Personalized service and dedicated customer support"
    }
  ];



// Corrected stats array with numbers and separate suffixes
const stats = [
  { number: 10000, suffix: "+", label: "Satisfied Customers" },
  { number: 5, suffix: "+", label: "Years Experience" },
  { number: 50, suffix: "+", label: "Vehicle Fleet" },
  { number: 99, suffix: "%", label: "On-time Rate" }
];

// CountUp Component for animated numbers
const CountUp = ({ end, duration = 2000, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });

  useEffect(() => {
    if (isInView) {
      let start = 0;
      const increment = end / (duration / 16); // 60fps
      
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.ceil(start));
        }
      }, 16);

      return () => clearInterval(timer);
    }
  }, [isInView, end, duration]);

  return (
    <span ref={ref}>
      {count.toLocaleString()}{suffix}
    </span>
  );
};

// Animation variants (make sure these are defined)
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const statVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};















  return (
    <div className="about-main">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container-about">
          <motion.div 
            className="about-hero-content"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
          >
            <motion.div className="about-hero-text" variants={itemVariants}>
              <motion.h1 
                className="about-hero-title"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.2 }}
              >
                Your Trusted <span className="gradient-text">Transportation Partner</span> in Sri Lanka
              </motion.h1>
              <motion.p 
                className="about-hero-description"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.4 }}
              >
                For over 5 years, Retionz Cabs has been providing reliable, safe, and comfortable 
                transportation services across Sri Lanka. We are committed to making every journey 
                memorable with our premium fleet and professional drivers.
              </motion.p>
            </motion.div>
            <motion.div 
              className="about-hero-image">
  
              <img src="/about_us.png" alt="Retionz Cabs Fleet" />
            </motion.div>
          </motion.div>
        </div>
      </section>






     
{/********************** vision and mission *********************************/}
    <section className="vision-mission-section">
      <div className="container">
        <motion.div
          className="vision-mission-header"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
        >
          <motion.h2 className="section-title" variants={itemVariants}>
            Our Vision & Mission
          </motion.h2>
          <motion.p className="section-subtitle" variants={itemVariants}>
            Driving excellence in transportation services
          </motion.p>
        </motion.div>

        <div className="vision-mission-grid">
          {/* Vision Card - Left Side */}
          <motion.div
            className="vision-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={cardVariants}
            whileHover="hover"
          >
    
            <div className="card-icon vision-icon">
              <FaEye />
            </div>
            
            <h3 className="card-title">Our Vision</h3>
            
            <div className="card-content">
              <p className="card-text">
                To be the most trusted and preferred mobility partner, seamlessly connecting 
                people and places with innovative, reliable, and sustainable transportation 
                solutions, whether for a quick ride or a long journey.
              </p>
            </div>

            <div className="vision-features">
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Trusted & Preferred</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Seamless Connectivity</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Innovative Solutions</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Sustainable Future</span>
              </div>
            </div>
          </motion.div>

          {/* Mission Card - Right Side */}
          <motion.div
            className="mission-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={cardVariants}
            whileHover="hover"
          >
            <div className="card-decoration mission-decoration">
              <div className="floating-element element-1">
          
              </div>
              <div className="floating-element element-2">
             
              </div>
              <div className="floating-element element-3">
        
              </div>
            </div>
            
            <div className="card-icon mission-icon">
              <FaBullseye />
            </div>
            
            <h3 className="card-title">Our Mission</h3>
            
            <div className="card-content">
              <p className="card-text">
                Our mission is to empower our customers' lives and businesses by providing 
                a comprehensive and effortless range of transportation options that exceed 
                expectations and create lasting value.
              </p>
            </div>

            <div className="mission-features">
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Customer Empowerment</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Comprehensive Solutions</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Effortless Experience</span>
              </div>
              <div className="feature-item">
                <div className="feature-dot"></div>
                <span>Lasting Value Creation</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>










      {/* Story Section */}
      <section className="our-story">
        <div className="container">
          <motion.div 
            className="story-content"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={containerVariants}
          >
            <motion.div className="story-image" variants={itemVariants}>
              <motion.img 
                src="/retions cabs 3.png" 
                alt="Our Story" 
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.4 }}
              />
              <motion.div 
                className="story-badge"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.6 }}
                viewport={{ once: true }}
              >
                <FaAward className="badge-icon" />
                <span>Since 2021</span>
              </motion.div>
            </motion.div>
            <motion.div className="story-text" variants={itemVariants}>
              <motion.h2 
                className="section-title"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                Our Journey
              </motion.h2>
              <motion.p 
                className="story-description"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
              >
                Founded in 2021 by Achala Liyanaarachchi, Retionz Cabs & Car Rentals started with a simple vision: 
                to provide reliable and safe transportation services that people could trust. 
                What began with just two vehicles has grown into one of Colombo's most trusted cab services.
              </motion.p>
              <motion.p 
                className="story-description"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                viewport={{ once: true }}
              >
                Today, we operate a modern fleet of vehicles and serve thousands of satisfied 
                customers across Sri Lanka, maintaining our commitment to excellence and customer satisfaction.
              </motion.p>
              
              <motion.div 
                className="story-features"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                viewport={{ once: true }}
              >
                {/* <motion.div 
                  className="feature-item"
                  whileHover={{ scale: 1.05, x: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  <FaCheckCircle className="feature-icon" />
                  <span>Licensed Professional Drivers</span>
                </motion.div>
                <motion.div 
                  className="feature-item"
                  whileHover={{ scale: 1.05, x: 10 }}
                  transition={{ duration: 0.2, delay: 0.1 }}
                >
                  <FaCheckCircle className="feature-icon" />
                  <span>GPS Tracked Vehicles</span>
                </motion.div>
                <motion.div 
                  className="feature-item"
                  whileHover={{ scale: 1.05, x: 10 }}
                  transition={{ duration: 0.2, delay: 0.2 }}
                >
                  <FaCheckCircle className="feature-icon" />
                  <span>24/7 Customer Support</span>
                </motion.div>*/}
              </motion.div> 
            </motion.div>
          </motion.div>
        </div>
      </section>




      {/* Stats Section */}
 <section className="stats-section">
    <div className="container">
      <motion.div 
        className="stats-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {stats.map((stat, index) => (
          <motion.div 
            key={index} 
            className="stat-card"
            variants={statVariants}
            whileHover={{ scale: 1.05, y: -5 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div 
              className="stat-number"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ 
                duration: 0.6, 
                delay: index * 0.2,
                type: "spring",
                stiffness: 100
              }}
              viewport={{ once: true }}
            >
              <CountUp 
                end={stat.number} 
                duration={2500} 
                suffix={stat.suffix}
              />
            </motion.div>
            <div className="stat-label">{stat.label}</div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>








      {/* Values Section
      <section className="values-section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Why Choose Retionz Cabs?</h2>
            <p className="section-subtitle">
              The principles that drive our commitment to excellence
            </p>
          </motion.div>
          <motion.div 
            className="values-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {values.map((value, index) => (
              <motion.div 
                key={index} 
                className="value-card"
                variants={cardVariants}
                whileHover="hover"
                custom={index}
              >
                <motion.div 
                  className="value-icon"
                  whileHover={{ scale: 1.2, rotate: 15 }}
                  transition={{ duration: 0.3 }}
                >
                  {value.icon}
                </motion.div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section> */}

      



      {/* Team Section */}
{/* Team Section */}
<section className="team-section">
  <div className="container">
    <motion.div 
      className="section-header"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h2 className="section-title">Meet Our Leadership</h2>
      <p className="section-subtitle">
        The dedicated professionals ensuring your safe and comfortable journey
      </p>
    </motion.div>
    
    <motion.div 
      className="team-grid"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {teamMembers.map((member, index) => (
        <motion.div 
          key={index} 
          className="team-card"
          variants={cardVariants}
          whileHover="hover"
          custom={index}
        >
          <div className="team-image-container">
            <div className="team-image">
              <motion.img 
                src={member.image} 
                alt={member.name}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.4 }}
              />
              <motion.div 
                className="team-overlay"
                initial={{ opacity: 0 }}
                whileHover={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <div className="social-links">
                  <a href={member.linkedin} aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  {/* <a href={member.twitter} aria-label="Twitter" target="_blank" rel="noopener noreferrer">
                    <FaTwitter />
                  </a> */}
                  <a href={`mailto:${member.email}`} aria-label="Email">
                    <FaEnvelope />
                  </a>
                </div>
              </motion.div>
            </div>
            <div className="experience-badge">
              <FaStar className="star-icon" />
              <span>Expert</span>
            </div>
          </div>
          
          <div className="team-info">
            <h3 className="team-name">{member.name}</h3>
            <p className="team-role">{member.role}</p>
            <p className="team-description">{member.description}</p>
          </div>
        </motion.div>
      ))}
    </motion.div>
  </div>
</section>




{/* our commitment section  */}
<section className="mission-section">
  <div className="container">
    <motion.div 
      className="mission-content"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
    >
      <motion.div 
        className="mission-text-full"
        variants={itemVariants}
      >
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Our Commitment
        </motion.h2>
        <motion.p 
          className="mission-description"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          To provide safe, reliable, and comfortable transportation services 
          that exceed customer expectations. We are dedicated to maintaining 
          the highest standards of service quality and customer satisfaction.
        </motion.p>
        <motion.p 
          className="mission-description"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
        >
          Every journey with Retionz Cabs is backed by our commitment to 
          punctuality, safety, and exceptional customer service.
        </motion.p>
        <motion.div 
          className="mission-points"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          {["GPS tracked vehicles", "24/7 customer support", "Regular vehicle maintenance"].map((point, index) => (
            <motion.div 
              key={index}
              className="mission-point"
              whileHover={{ scale: 1.05, x: 10 }}
              transition={{ duration: 0.2, delay: index * 0.1 }}
            >
              <FaCheckCircle className="point-icon" />
              <span>{point}</span>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </motion.div>
  </div>
</section>




      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <motion.div 
            className="about-cta-content"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <motion.h2 
              className="cta-title"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              Ready for a Comfortable Ride?
            </motion.h2>
            <motion.p 
              className="cta-description"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
            >
              Experience the Retionz Cabs difference. Book your ride today and 
              enjoy safe, reliable, and comfortable transportation across Sri Lanka.
            </motion.p>
            <motion.div 
              className="cta-buttons"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <Link to="/bookings">
              <motion.button 
                className="btn btn-primary-book-now"
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                Book Now
              </motion.button></Link>
                <motion.button 
                  className="btn btn-secondary-call-about"
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => window.location.href = 'tel:+94701707707'}
                >
                  Call Us: +94 70 170 7707
                </motion.button>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;